const setFristChildrenCitizenId = (data = null) => {
  return {
    type: 'SET_FRISTCHILDRENCITIZENID',
    data
  }
}

export default {
  setFristChildrenCitizenId,
}
